import { render } from "./SingleUser.vue?vue&type=template&id=2719b443"
import script from "./SingleUser.vue?vue&type=script&lang=js"
export * from "./SingleUser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__